export default __webpack_public_path__ + "static/media/small-logotipo.93eb2c5b.svg";